import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import type { ProgramSource } from "@/services/adminProgramNews";
import SourceRow from "./SourceRow";

interface SourceTableProps {
  sources: ProgramSource[];
  /** False outside QA: rows render without any action controls. */
  writable: boolean;
  onSetOverride: (teamId: string, url: string, reason: string) => Promise<unknown>;
  onDisable: (teamId: string, reason: string) => Promise<unknown>;
  onEnable: (teamId: string) => Promise<unknown>;
}

const SourceTable = ({
  sources,
  writable,
  onSetOverride,
  onDisable,
  onEnable,
}: SourceTableProps) => {
  if (sources.length === 0) {
    return (
      <div className="py-8 text-center text-muted-foreground">No sources match this filter.</div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Team</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>CMS</TableHead>
            <TableHead>Source URL</TableHead>
            <TableHead>Last Attempt</TableHead>
            <TableHead className="w-[1%]" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {sources.map(source => (
            <SourceRow
              key={source.teamId}
              source={source}
              writable={writable}
              onSetOverride={onSetOverride}
              onDisable={onDisable}
              onEnable={onEnable}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default SourceTable;
